import {Button} from '@wandb/weave/components/Button';
import React, {useMemo} from 'react';
import {twMerge} from 'tailwind-merge';

import * as PanelBankSectionConfigTypes from '../../state/views/panelBankSectionConfig/types';
import {getPanelSpec, PanelType} from '../../util/panelTypes';
import {FullScreenPanelOverflowMenu} from './FullScreenPanelOverflowMenu';
import {useGoToBaseUrl} from './hooks';
import {usePanelContext} from './PanelContextProvider';
import {FullScreenPanelEditButton} from './PanelEditButton';
import {FullScreenPanelRunMetricButton} from './PanelRunMetricButton';

export const FullScreenPanelHeader = ({
  panelBankSectionConfigRef,
  panelType,
}: {
  panelBankSectionConfigRef: PanelBankSectionConfigTypes.Ref;
  panelType: PanelType;
}) => {
  const {panelRef} = usePanelContext();
  const goToBaseURL = useGoToBaseUrl();

  const panelSpec = useMemo(() => getPanelSpec(panelType), [panelType]);

  return (
    <div
      className={twMerge(
        'flex shrink-0',
        // since we have more real estable in full screen mode, we should add more spacing between panel header and panel content itself
        'mb-18 min-h-[32px]'
      )}
      data-test="panel-header">
      <div className="flex w-full justify-between">
        <Button
          aria-label="Back"
          icon="back"
          variant="ghost"
          onClick={goToBaseURL}
        />
        <div className="flex">
          <FullScreenPanelRunMetricButton
            panelBankSectionConfigRef={panelBankSectionConfigRef}
            panelRef={panelRef}
            panelType={panelType}
          />
          <FullScreenPanelEditButton />
          <FullScreenPanelOverflowMenu
            panelBankSectionConfigRef={panelBankSectionConfigRef}
            panelSpec={panelSpec}
          />
        </div>
      </div>
    </div>
  );
};
